import History from '@/pages/administration/HistoryPage.vue'
import Dashboard from '@/pages/administration/DashboardPage.vue'
import AuditLogs from '@/pages/administration/AuditLogsPage.vue'
import VIBANManagement from '@/pages/administration/VIBANManagementPage.vue'
import TransactionLedger from '@/pages/administration/TransactionLedgerPage.vue'
import UserManagement from '@/pages/administration/UserManagementPage.vue'
import ReconciliationLedger from '@/pages/administration/ReconciliationLedgerPage.vue'
import Configuration from '@/pages/administration/ConfigurationPage.vue'
import DailyReport from '@/pages/administration/DailyReportPage.vue'
import Documentation from '@/pages/administration/DocumentationPage.vue'
import Simulation from '@/pages/administration/SimulationPage.vue'

export default [
  {
    path: '/history/',
    component: History
  },
  {
    path: '/simulation/',
    component: Simulation
  },
  {
    path: '/dashboard/',
    component: Dashboard
  },
  {
    path: '/vibanmanagement/',
    component: VIBANManagement
  },
  {
    path: '/transactionledger/:id',
    component: TransactionLedger
  },
  {
    path: '/dailyreport/',
    component: DailyReport
  },
  {
    path: '/documentation/',
    component: Documentation
  },
  {
    path: '/configuration/',
    component: Configuration
  },
  {
    path: '/reconciliationledger/',
    component: ReconciliationLedger
  },
  {
    path: '/usermanagement/',
    component: UserManagement
  },
  {
    path: '/auditlogs/',
    component: AuditLogs
  }
]
